import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  designations: [], // Initial designations array
  isDefaultSet: false,
};

const designationSlice = createSlice({
  name: 'designation',
  initialState,
  reducers: {
    setDesignation: (state, action) => {
      state.designations = action.payload;
      state.isDefaultSet = action.payload.some((desig) => desig.isDefault);
    },
    addDesignation: (state, action) => {
      state.designations.push(action.payload);
      if (action.payload.isDefault) {
        state.isDefaultSet = true;
      }
    },
    updateDesignation: (state, action) => {
      const updatedDesignation = action.payload;

      if (updatedDesignation.isDefault) {
        // Set isDefault to false for previous default designations
        const updatedPrevDesignations = state.designations.map((prevDesignation) =>
          prevDesignation.isDefault
            ? { ...prevDesignation, isDefault: false }
            : prevDesignation
        );

        state.designations = updatedPrevDesignations.map((prevDesignation) =>
          prevDesignation.id === updatedDesignation.id ? updatedDesignation : prevDesignation
        );
        state.isDefaultSet = true;
      }

      state.designations = state.designations.map((prevDesignation) =>
        prevDesignation.id === updatedDesignation.id ? updatedDesignation : prevDesignation
      );

    },
    deleteDesignation: (state, action) => {
      const designationIndex = state.designations.findIndex(
        (designation) => designation.id === action.payload
      );
      if (designationIndex !== -1) {
        const deletedDesignation = state.designations[designationIndex];
        state.designations.splice(designationIndex, 1);

        if (deletedDesignation.isDefault) {
          state.isDefaultSet = state.designations.some((desig) => desig.isDefault);
        }
      }
    },
    setIsDefaultSet: (state, action) => {
      state.isDefaultSet = action.payload;
    },
  },
});

export const {
  setDesignation,
  addDesignation,
  updateDesignation,
  deleteDesignation,
  setIsDefaultSet
} = designationSlice.actions;

export default designationSlice.reducer;